import { type SupportedColorScheme } from '@mui/material/styles';

/**
 * returns a function that a style object containing filter property with invert and grayscale filters
 * used on providers images to invert them when the theme is dark
 * and grayscale them when they are inside a disabled button
 */
export const imageFilters = (colorScheme: SupportedColorScheme, isDisabled = false, themed = true) => {
  const invertFilter = themed && colorScheme === 'dark' ? 'invert(1)' : '';
  const greyScaleFilter = isDisabled ? 'grayscale(1)' : '';
  const filter = `${invertFilter} ${greyScaleFilter}`;

  return { filter };
};
